import { Typography } from "@kelp-dao/kernel-design-system";
import { ShieldCheckIcon } from "@phosphor-icons/react";

const Insured = ({
  variant = "default",
}: {
  variant?: "default" | "small";
}) => {
  const isSmall = variant === "small";

  return (
    <div
      className={`flex items-center gap-1 bg-[#DDEFF0] ${
        isSmall ? "px-2 py-1 rounded-[16px]" : "px-3 py-2 rounded-[8px]"
      }`}
    >
      <ShieldCheckIcon
        weight="fill"
        className={`text-[#28B58E] ${isSmall ? "w-4 h-4" : "w-6 h-6"}`}
      />
      <Typography
        type="body"
        className={`${
          isSmall
            ? "text-[10px] font-semibold leading-[13px]"
            : "text-base font-normal leading-[20px]"
        } text-text-primary`}
      >
        Insured
      </Typography>
    </div>
  );
};

export default Insured;
